import LoadingStatus from '@libs/loading-status';

import {
  USER_AUTHORITY__FETCH_FAILURE,
  USER_AUTHORITY__FETCH_REQUEST,
  USER_AUTHORITY__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import {
  checkSigningRequestAuthority,
  UserAuthorityAction,
} from '@app/store/user/authority/actions';

export type UserAuthorityLoadingStatusState = LoadingStatus;

const initialState = LoadingStatus.IDLE;

export default function reducer(
  state: UserAuthorityLoadingStatusState = initialState,
  action: UserAuthorityAction
) {
  if (checkSigningRequestAuthority.pending.match(action)) {
    return LoadingStatus.PENDING;
  }

  switch (action.type) {
    case USER_AUTHORITY__FETCH_REQUEST:
      return LoadingStatus.PENDING;
    case USER_AUTHORITY__FETCH_SUCCESS:
      return LoadingStatus.SUCCEEDED;
    case USER_AUTHORITY__FETCH_FAILURE:
      return LoadingStatus.FAILED;
    default:
      return state;
  }
}
